module.exports = __webpack_public_path__ + "static/backed-9c33a4e4027223e3f8816ccda58b0c4f.svg";